module.exports = "<div  class=\"toast-container {{position}}\" style=\"z-index:65252;\">\r\n    <div *ngFor=\"let message of messages;\" style=\"visibility:hidden;\" class=\"{{message.status}} toast-card mdl-shadow--16dp\">\r\n        <!--<h5 class=\"toast-title\">{{message.title}}</h5>-->\r\n        <span class=\"toast-message\">{{message.message}}</span>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rx/view/toast/rx_toast_control_component.html
// module id = ./node_modules/@rx/view/toast/rx_toast_control_component.html
// module chunks = vendor